import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Identifiers' },
    { value: 2, label: 'Enrolments' },
    { value: 3, label: 'Unenrolments' },
    { value: 4, label: 'Roll Return' },
    { value: 5, label: 'Attendance Surveys' },
    { value: 6, label: 'Ping' },
    { value: 8, label: 'Attendance Corrections' },
  ],
});
